import { Component, OnInit, Input, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { SubscriptionService } from '../../AdviserComponent/Subscriptions/subscription.service';
import { EventService } from 'src/app/Data-service/event.service';
import { FormControl, Validators } from '@angular/forms';
import { SupportService } from '../../SupportComponent/support.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { AuthService } from 'src/app/auth-service/authService';

@Component({
  selector: 'app-replace-user',
  templateUrl: './replace-user.component.html',
  styleUrls: ['./replace-user.component.scss']
})
export class ReplaceUserComponent implements OnInit {
  //user = new FormControl('', [Validators.required]);
  rmUser = new FormControl('', [Validators.required]);
  salesUser = new FormControl('', [Validators.required]);
  reSellerUser = new FormControl('');
  opsRMUser = new FormControl('', [Validators.required]);
  opsCampaign = new FormControl('', [Validators.required]);
  addResponse: any;
  rm: any[] = [];
  campign: any[] = [];
  salesRM: any[] = [];
  resellerRM: any[] = [];
  opsRM: any[] = [];
  userList: any[] = [];
  user: any[] = [];
  campignList: any[] = [];
  campaignMasterId: number;
  advisorId: any;
  flag: any;

  constructor(
    private supportService: SupportService,
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
  ) {


  }

  ngOnInit() {
    this.advisorId = this.dialogData.userDetails.advisorId
    // console.log(this.advisorId )


    // this.opsCampaign.valueChanges.subscribe(res =>{
    //   if(res == 'pgim'){
    //     this.campaignMasterId = 1
    //   }else if(res == 'offer'){
    //     this.campaignMasterId = 2
    //   }else if(res == 'regular'){
    //     this.campaignMasterId = 3
    //   }else if(res == '5k new advisors'){
    //     this.campaignMasterId = 4
    //   }else if(res == 'reactivation'){
    //     this.campaignMasterId = 5
    //   }else if(res == 'small aum - 5k/10k'){
    //     this.campaignMasterId = 6
    //   }else if(res == 'refer & earn'){
    //     this.campaignMasterId = 7
    //   }


    // })
    // console.log(this.opsCampaign.value)
    this.getCamapignList();
    // console.log('dialogData', this.dialogData);
    this.flag = this.dialogData.flagSend
    this.userList = this.dialogData.userList;
    // console.log('userList', this.userList);
    this.userList.forEach(ele1 => {
      if (ele1.id) {
        this.campign.push(ele1)

      }



    })
    // console.log('campignList',this.campignList)
    this.userList.forEach(element => {
      if (element.typeId == 2) {
        this.rm.push(element);
      } else if (element.typeId == 3) {
        this.salesRM.push(element);
      } else if (element.typeId == 4) {
        this.resellerRM.push(element);
      } else if (element.typeId == 6) {
        this.opsRM.push(element);
      }
    });

    this.rm.sort((a, b) => a.name.localeCompare(b.name));
    this.salesRM.sort((a, b) => a.name.localeCompare(b.name));
    this.resellerRM.sort((a, b) => a.name.localeCompare(b.name));
    this.opsRM.sort((a, b) => a.name.localeCompare(b.name));

    console.log('rm', this.rm, 'salesRm', this.salesRM, 'reseller', this.resellerRM, 'campign', this.campign);


  }

  getObjectVal(val, event) {
    if (event.isUserInput == true) {
      this.campaignMasterId = val.id
    }

  }

  clickNo() {
    if (this.dialogData.onNoClick) {
      this.dialogData.onNoClick();
      this.dialogClose();
    } else {
      this.dialogClose();
    }
  }



  mapAdvisors() {
    const obj = {
      "advisorId": this.advisorId,
      "campaignMasterId": this.campaignMasterId
    }

    this.supportService.updateCampaignApi(obj).subscribe((res) => {
      if (res) {
        // this.campignList = res
      }
    })
  }

  clickYes() {
    if (this.flag == false) {
      this.mapAdvisors()
      if (this.rmUser.valid && this.salesUser.valid && this.opsRMUser.valid && this.opsCampaign) {
        // this.addToSpreadSheet()
        this.user['rmId'] = this.rmUser.value,
          this.user['salesRmId'] = this.salesUser.value,
          this.user['reSellerRmId'] = (this.reSellerUser.value) ? this.reSellerUser.value : 0,
          this.user['opsRmId'] = this.opsRMUser.value

        // this.user['opsCampaign'] = this.opsCampaign.value


        this.dialogRef.close(this.user);
      }
      else {

        this.rmUser.markAsTouched();
        this.salesUser.markAsTouched();
        this.opsRMUser.markAsTouched();
        this.opsCampaign.markAllAsTouched();
      }

    }
    else {
      if (this.rmUser.valid && this.salesUser.valid && this.opsRMUser.valid && this.opsCampaign) {
        // this.addToSpreadSheet()
        this.user['rmId'] = this.rmUser.value,
          this.user['salesRmId'] = this.salesUser.value,
          this.user['reSellerRmId'] = (this.reSellerUser.value) ? this.reSellerUser.value : 0,
          this.user['opsRmId'] = this.opsRMUser.value,
          this.user['advisorId'] = this.advisorId,
          this.user['campaignMasterId'] = this.campaignMasterId

        this.dialogRef.close(this.user);
      }
      else {
        this.rmUser.markAsTouched();
        this.salesUser.markAsTouched();
        this.opsRMUser.markAsTouched();
        this.opsCampaign.markAllAsTouched();
      }

    }



  }


  getCamapignList() {
    this.supportService.getCamapignListA().subscribe((res) => {
      if (res) {
        this.campignList = res.sort((a, b) => {
          const nameA = (a.companyName || '').toLowerCase();
          const nameB = (b.companyName || '').toLowerCase();
          return nameA.localeCompare(nameB);
        });

      }
    })

  }


  // getCamapignList(){
  //   this.supportService.getCamapignListA().subscribe((res) => {
  //     if (res) {
  //       // this.getRemarkComments();
  //       console.log(res)
  //     }
  //   }),
  // }






  // addToSpreadSheet() {
  //   let advisorId = this.dialogData.userDetails.advisorId.toString()
  //   let rmMasterId = this.user.value.toString()
  //   const obj = {
  //     sheetPayload: [
  //       {
  //         range: "rm_details!A:B",
  //         sheetId: "1yIFPn1HVpug26k_XrRMrt0B2GIrxCmXNByLS8DTZTcE",
  //         values: [[advisorId, rmMasterId]],
  //       },
  //     ],
  //   };
  //   console.log('spreadsheet', obj)
  //   this.supportService.appendToSpreadSheet(obj).subscribe(data => {
  //     this.addResponse = data;
  //     console.log('add-response', this.addResponse)
  //   })
  // }



  clickUnmap() {
    this.dialogClose(true);
  }

  dialogClose(result = false) {
    this.dialogRef.close(result);
  }
}
